// extracted by mini-css-extract-plugin
export default {"root":"Vi2vpTb9T8CosEKNPx1n","mobile":"YUKRLWAfbUeTWLmX1p8r","title":"iP7_Z9HVj7yysAJTfCiu","text":"hvCIBWLqihob83m2hYZ8","divider":"WUpJPHGx38fy3cH0uVTv"};